
import React, { useState, useEffect } from 'react';

// Custom hook to detect small screens
function useIsSmallScreen() {
  const [isSmall, setIsSmall] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsSmall(window.innerWidth < 768); // Tailwind md breakpoint is 768px
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isSmall;
}

function DesktopWarningBanner({ isDesktop }) {
  const isSmallScreen = useIsSmallScreen();
  const [isDismissed, setIsDismissed] = useState(false);
  
  // If not desktop mode, or not a small screen, or already dismissed, don't show
  if (!isDesktop || !isSmallScreen || isDismissed) return null;
  
  return (
    <div className="bg-slate-50 border-l-4 border-slate-400 p-4 mx-4 mb-6 flex justify-between items-center">
      <p className="text-sm text-slate-800">
        Best viewed on a wider screen.
      </p>
      <button
        onClick={() => setIsDismissed(true)}
        className="text-slate-500 hover:text-slate-700"
        aria-label="Dismiss"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>
    </div>
  );
}

export default DesktopWarningBanner;